import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {IDocumentTypesDto} from 'app/main/pages/documents/dto/document-listing.dto';
import {DocumentTypeService, IFetchDocumentLayoutSettings} from 'app/main/pages/settings/documenttype/document-type.service';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import {combineLatest, from, Observable, startWith, Subject} from 'rxjs';
import {map, take, takeUntil} from 'rxjs/operators';
import {IAdvancedFilterListItem, IAdvanceFilter} from '../../../shared/advanced-filters/components/advance-filter';
import {SaveFilterComponent} from '../../../shared/save-listing-filters/components/save-filter/save-filter.component';
import {SavedFiltersComponent} from '../../../shared/save-listing-filters/components/saved-filters/saved-filters.component';
import {IGetSavedListingFiltersResponseDTO} from '../../../shared/save-listing-filters/save-filters.dto';
import {SavedListingFiltersEffects} from '../../../shared/save-listing-filters/store/saved-filters.effects';
import {IGetCategoriesItemDto} from '../../categories.dto';
import {ContractControlEmitterService} from '../../events/contract-control-emitter.service';
import {ContractControlAdvanceFilterParamType} from '../advanced-filters';
import {ContractControlHelperService} from '../contract-control-helpers/contract-control-helper.service';
import {DefaultFilter} from '../contract-control-interfaces/default-filters.interface';
import {GetContractControlRequestBuilder} from '../get-contract-control-request-builder';
import {ContractControlFacade} from '../store/facades/contract-control-facade';
import { DocumentTypeSectionEnum } from '../../settings/documenttype/document-type-settings-modal/default-constants/document-type-settings.constants';

export const ContractControlListingStatusFilter = [
    {id: 1, name: 'All', value: 'all'},
    {id: 2, name: 'Active', value: '1'},
    {id: 3, name: 'Inactive', value: '0'}
]


@Component({
    selector: 'app-contract-control-filters',
    templateUrl: './contract-control-filters.component.html',
    styleUrls: ['./contract-control-filters.component.scss'],
    encapsulation: ViewEncapsulation.None,

})
export class ContractControlFiltersComponent implements OnInit, AfterViewInit, OnDestroy {
    private _defaultFilter = {} as DefaultFilter;
    private readonly noCategoryValue = 'no_category';
    private readonly noCategoryId = -1;
    private destroy$ = new Subject<void>();

    @Input() activeView: string = 'table_view';
    @Input() categories: IGetCategoriesItemDto[] = [];
    @Input() documentTypeLayoutSettings: IFetchDocumentLayoutSettings = null;
    @Output() fetchLayoutSettings: EventEmitter<IFetchDocumentLayoutSettings> = new EventEmitter();
    @Input({required: true}) requestBuilder:GetContractControlRequestBuilder
    public selectedCategoryId: number = 0;
    @Input() set defaultFilter(filter: DefaultFilter) {
        const parsedCategoryIds = this.normalizeCategoryIds(filter?.category_ids);
        this._defaultFilter = {
            status: filter?.status ?? null ,
            document_type: filter?.document_type ? parseInt(filter?.document_type?.toString()) : null,
            category_ids: parsedCategoryIds,
            search: filter.search
        };
        this.selectedCategoryId = parsedCategoryIds?.[0] ?? 0;

        this.defaultFilterForm?.patchValue({
            status:  this._defaultFilter.status==null ? this.contractStatuaFilter[0].value :this._defaultFilter.status,
            document_type: this._defaultFilter?.document_type,
            category_ids: this._defaultFilter?.category_ids,
            search:this._defaultFilter?.search
        }, { emitEvent: false });

        if (this.defaultFilterForm) {
            this.generateFilter(this.defaultFilterForm.value);
        }
    }

    @Output() defaultFilterChange: EventEmitter<DefaultFilter> = new EventEmitter();

    get defaultFilter() {
        return this._defaultFilter;
    }

    public selectedDocumentType: IDocumentTypesDto | null;
    public defaultFilterForm: FormGroup;
    public readonly = false;
    public searchable = false;
    public filter: string;
    public perPageRecords:number = 20

    public contractStatuaFilter = ContractControlListingStatusFilter;

    public advancedFiltersList$: Observable<IAdvancedFilterListItem<ContractControlAdvanceFilterParamType>[]> = this._contractControlFacade.advancedFiltersList$;
    public isAdvancedFiltersListLoading$: Observable<boolean> = this._contractControlFacade.isAdvancedFiltersListLoading$;
    public appliedAdvancedFilters$: Observable<IAdvanceFilter<ContractControlAdvanceFilterParamType>[]> = this._contractControlFacade.appliedAdvancedFilters$.pipe(map(x => ([...x])));
    public savedFiltersList$: Observable<IGetSavedListingFiltersResponseDTO[]> = this._contractControlFacade.savedFilters$;
    public selectedSavedFilterId$: Observable<number> = this._contractControlFacade.selectedSavedFilterId$;
    public hasAnyFiltersApplied$:Observable<boolean> = combineLatest({
        advancedFiltersApplied: this.appliedAdvancedFilters$.pipe(  map(x=>x.length > 0)),
        defaultFiltersApplied: this.controlControlEmitter.getDefaultFilters().pipe(startWith(null) , map(x=> (x?.status != null && x?.status!= 'all') || (x && Object.keys(x).filter(y=>y !== 'status').some(z=>x[z]!=null))))
    }).pipe(map(x=> x.advancedFiltersApplied || x.defaultFiltersApplied));
    public allFiltersValid$ :Observable<boolean> = this.appliedAdvancedFilters$.pipe(map(x=>x.every(y=> y.isApplied ===true)))
   
    public documentTypes$ = this._sharedStoreFacade$.filterDocumentTypes$;
    get showAdvancedFilters (){
        return ["table_view", "cc_graph_view"].includes(this.activeView);
    }


    constructor(private _formBuilder: FormBuilder,
                private controlControlEmitter: ContractControlEmitterService,
                private _contractControlFacade: ContractControlFacade,
                private documentTypeService: DocumentTypeService,
                private _savedListingFiltersEffects:SavedListingFiltersEffects,
                private _modalService: NgbModal,
                private _contractControlHelper$: ContractControlHelperService,
                private _cdr: ChangeDetectorRef,
                private _sharedStoreFacade$: SharedStoreFacade
            ) {
    }


    ngOnInit(): void {
        //  const data = this.getSeletedFilters(this.defaultFilter);
        const data = this.defaultFilter;
        const parsedCategoryIds = this.normalizeCategoryIds(data?.category_ids);
        this.defaultFilterForm = this._formBuilder.group({
            status: [data?.status == null ? null : (data?.status == '1' ? '1' : '0')],
            document_type: [data?.document_type ? parseInt(data?.document_type?.toString()) : null],
            category_ids: parsedCategoryIds,
            search: [data?.search ? data?.search : null],
        });

        this.selectedCategoryId = parsedCategoryIds?.[0] ?? 0;

        this.defaultFilterForm.get('category_ids')?.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((ids: number[] | null) => {
                this.selectedCategoryId = ids?.[0] ?? 0;
            });

        this.defaultFilterForm.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((response) => {
                this.generateFilter(response);
            });
    }



    ngAfterViewInit(): void {
        Promise.resolve().then(() => this._cdr.detectChanges());
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setPerPageRecords(value: number){
        this.perPageRecords = value;
        this.requestBuilder.updatePerPageRecord(value);
        this._contractControlHelper$.refreshContractList();
    }


    /**
     * Generate default filter string
     * @param filters
     */
    generateFilter(filters = {} as DefaultFilter) {
        this.controlControlEmitter.setDefaultFilters(filters);
        this.defaultFilterChange.emit(filters);
    }

    advancedFilterSearch($event: string) {
        this._contractControlFacade.advancedFilterSearch($event);
    }

    onRemoveFilter(filter: IAdvanceFilter<ContractControlAdvanceFilterParamType>) {
        this._contractControlFacade.onRemoveFilter(filter);
        this._contractControlFacade.clearSavedFilterSelection();
    }

    onSelectedSavedFilterChange(filterId: number) {
        this._contractControlFacade.restoreFilter(filterId);
    }

    /**
     *This function will apply document type layout settings
     * @param documentTypeId 
     */
    applyDocumentTypeLayoutSettings(documentType: IDocumentTypesDto | null){
        this._contractControlFacade.clearSavedFilterSelection();
        this.selectedDocumentType = documentType;

        const columns = documentType?.sections?.find(x => x.name === DocumentTypeSectionEnum.ContractControlColumns);
        if (documentType?.id && columns?.columns?.length) {
            const columnSettings = columns.columns.map(field => ({
                uuid: String(field.id),
                field_name: field.field_name,
                label: field.label,
                order: field.order,
                doc_id: field.meta_data_id,
                status: field.status ? 1 : 0,
                type: field.type,
                details: field.meta_data_id ? field.meta_data : null
            }));
            this._contractControlFacade.setCustomColumnSettingsDetails(columnSettings);
        } else {
            // "All" (null/0) or missing overrides should restore saved listing settings.
            this._contractControlFacade.fetchCustomColumnSettings();
        }
    }


    addNewFilter($event:Omit<IAdvanceFilter<ContractControlAdvanceFilterParamType>, "uuid">) {
        this._contractControlFacade.addNewFilter($event);
        this._contractControlFacade.clearSavedFilterSelection();
    }

    onSaveFilterClicked() {
        const instance = this._modalService.open(SaveFilterComponent, {
            size: 'm'
        });

        (instance.componentInstance as SaveFilterComponent).saveFilter
            .subscribe(x => {
                (instance.componentInstance as SaveFilterComponent).isLoading = true;
                this._contractControlFacade.saveFilter({
                    ...x,
                    value: this.requestBuilder.build()
                });

                this._savedListingFiltersEffects.saveFiltersSucceeded
                    .pipe(take((1)))
                    .subscribe(()=>{
                        instance.close();
                    });
            });
    }

    manageSavedFilters(){
        const instance = this._modalService.open(SavedFiltersComponent, {
            size: 'lg'
        });

        const subscription = combineLatest({
            filters: this._contractControlFacade.savedFilters$
        })
            .pipe(takeUntil(from(instance.result.finally())))
            .subscribe(({filters}) => {
                (instance.componentInstance as SavedFiltersComponent).filters = filters;
            });
        instance.result.finally(() => {
            subscription.unsubscribe();
        });
        (instance.componentInstance as SavedFiltersComponent).editFilter
            .subscribe(x => {
                this._contractControlFacade.editFilter(x);
            });
        (instance.componentInstance as SavedFiltersComponent).deleteFilter
            .subscribe(x => {
                this._contractControlFacade.deleteFilter(x.id);
            });
    }

    onStatusSelect() {
        this._contractControlFacade.clearSavedFilterSelection();
    }


    onCategorySelectChange(category: IGetCategoriesItemDto | number | null): void {
        const id = typeof category === 'number' ? category : (category?.id ?? 0);

        if (id === this.noCategoryId) {
            this.selectedCategoryId = this.noCategoryId;
            this.defaultFilterForm.get('category_ids')?.setValue([this.noCategoryId]);
            this.onCategorySelect();
            return;
        }

        if (id) {
            this.selectedCategoryId = Number(id);
            this.defaultFilterForm.get('category_ids')?.setValue([Number(id)]);
            this.onCategorySelect();
        } else {
            this.selectedCategoryId = 0;
            this.defaultFilterForm.get('category_ids')?.setValue(null);
            this.onCategorySelect();
        }
    }

    onCategorySelect() {
        this._contractControlFacade.clearSavedFilterSelection();
    }

    private normalizeCategoryIds(categoryIds: DefaultFilter['category_ids']): number[] | null {
        if (categoryIds === this.noCategoryValue || categoryIds === this.noCategoryId) {
            return [this.noCategoryId];
        }
        if (Array.isArray(categoryIds)) {
            const normalized = categoryIds
                .map(x => Number(x))
                .filter(x => !Number.isNaN(x));
            return normalized.length ? normalized : null;
        }
        if (categoryIds) {
            const parsed = Number(categoryIds);
            return Number.isNaN(parsed) ? null : [parsed];
        }
        return null;
    }
}
